<input *ngIf="props.type == 'text'"
       class="form-control"
       [disabled]="props.disabled"
       [required]="props.required"
       [ngModel]="props.value"
       (input)="change($event.target.value)" />

<textarea *ngIf="props.type == 'note'"
          class="form-control"
          rows="5"
          [disabled]="props.disabled"
          [required]="props.required"
          [ngModel]="props.value"
          (input)="change($event.target.value)"></textarea>

<app-select *ngIf="props.type == 'choice'"
            [options]="props.choices || []"
            [valueFn]="props.choiceValueFn"
            [displayFn]="props.choiceDisplayFn"
            [ngModel]="props.value"
            [disabled]="props.disabled"
            [required]="props.required"
            [clear]="true"
            (selectionChange)="change($event)">
</app-select>

<app-date *ngIf="props.type == 'date'"
          [disabled]="props.disabled"
          [required]="props.required"
          [ngModel]="props.value"
          [min]="props.min"
          [max]="props.max"
          (dateChange)="change($event)">
</app-date>
